import Session, {
  IS_DEBUG,
  IS_SCENARIO_MODE,
} from '../common/services/Session';
import {
  PATH_DEBUG_SUMMARY,
  PATH_LOCK_SUMMARY,
  PATH_SCENARIO_SUMMARY,
} from './constants';

// Resolves the summary route to navigate to after a product/rate is selected in
// the results grids. Tech Ops debug and Scenario flows have their own read-only
// summaries; everything else uses the standard lock summary.
export const getSelectedProductSummaryPath = (): string => {
  if (Session.get(IS_DEBUG)) return PATH_DEBUG_SUMMARY;
  if (Session.get(IS_SCENARIO_MODE)) return PATH_SCENARIO_SUMMARY;
  return PATH_LOCK_SUMMARY;
};
